import React from "react";
import AddItemModal from "./AddItemModal";
import Breadcrumb from "../../../components/Breadcrumb";
import { addContractNameDataAsync } from "../../../lib/common-service";
import { getUserCredential } from "../../../lib/cookies";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router";

const AddContractName = ({ isVisible, onClose, onSave, breadcrumbData = {} }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const cookiesData = getUserCredential();
  const fields = [
    {
      name: "contract_name",
      label: "Contract Name",
      type: "text",
      required: true,
      autoFocus: true,
      placeholder: "Enter Contract Name",
      errorMessage: "Contract name is required",
    },
    {
      name: "contract_name_desc",
      label: "Description",
      type: "textarea",
      required: false,
      placeholder: "Enter Contract Desc.",
      rows: 3,
    },
  ];

  const initialData = {
    contract_name: "",
    contract_name_desc: "",
  };

  const apiConfig = {
    fieldType: "contract_name",
    endpoint: "/api/contract-names", // Future API endpoint
    method: "POST",
  };

  const handleSave = async (data) => {
    // Format data for API call
    const bodyData = {
      in_user_id: cookiesData.out_user_id,
      in_tenant_id: cookiesData.out_tenant_id,
      in_task_name: data.contract_name,
      in_task_desc: data.contract_name_desc || "",
      in_task_unittype: 122, // Required: pass as 122
    };

    try {
      // Make API call to add contract name
      const result = await addContractNameDataAsync(bodyData, history, dispatch);

      if (result) {
        // Create contract name object for parent component
        const newContractName = {
          text: data.contract_name,
          id: data.contract_name.toLowerCase().replace(/\s+/g, "_"),
          desc: data.contract_name_desc || "",
        };

        // Call parent onSave function
        await onSave(newContractName);
        return true; // Success
      } else {
        return false; // API call failed
      }
    } catch (error) {
      console.error("Error adding contract name:", error);
      return false; // Error occurred
    }
  };

  // Render breadcrumb if context data is available
  const renderBreadcrumb = () => {
    const breadcrumbItems = [];

    if (breadcrumbData.division) {
      breadcrumbItems.push({
        id: "division",
        label: "Division",
        value: breadcrumbData.division,
      });
    }

    if (breadcrumbData.hospital) {
      breadcrumbItems.push({
        id: "hospital",
        label: "Hospital/Location",
        value: breadcrumbData.hospital,
      });
    }

    if (breadcrumbData.specialty) {
      breadcrumbItems.push({
        id: "specialty",
        label: "Specialty",
        value: breadcrumbData.specialty,
      });
    }

    if (breadcrumbData.contractType) {
      breadcrumbItems.push({
        id: "contractType",
        label: "Contract Type",
        value: breadcrumbData.contractType,
      });
    }

    if (breadcrumbItems.length === 0) return null;

    return <Breadcrumb items={breadcrumbItems} />;
  };

  return (
    <AddItemModal
      isVisible={isVisible}
      onClose={onClose}
      onSave={handleSave}
      title="Add Contract Name"
      fields={fields}
      initialData={initialData}
      apiConfig={apiConfig}
      breadcrumb={renderBreadcrumb()}
      modalClass="contract-name-modal"
      width={800}
    />
  );
};

export default React.memo(AddContractName);
